<template>
  <div>
    <div class="changerecordtitle">数据列表</div>
    <el-table :data="tableData"
              border
              style="width: 100%">
      <el-table-column type="index"
                       label="序号"
                       fixed
                       width="50">
      </el-table-column>
      <el-table-column fixed
                       prop="date"
                       label="变更记录"
                       width="150">
      </el-table-column>
      <el-table-column prop="name"
                       label="变更原因"
                       width="120">
      </el-table-column>
      <el-table-column prop="province"
                       label="操作人"
                       min-width="200">
      </el-table-column>
      <el-table-column prop="city"
                       label="时间"
                       width="120">
      </el-table-column>
    </el-table>
    <el-pagination :current-page="page"
                   :page-sizes="[10, 20, 50, 100]"
                   :page-size="limit"
                   :total="total"
                   layout="total, sizes, prev, pager, next, jumper"
                   @size-change="pageSizeChangeHandle"
                   @current-change="pageCurrentChangeHandle">
    </el-pagination>
  </div>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/log/login/page',
        getDataListIsPage: true,
        exportURL: '/sys/log/login/export'
      },
      tableData: [
        {
          date: '12345',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1516 弄',
          zip: 200333,
          value: false
        },
        {
          date: '12345',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1516 弄',
          zip: 200333,
          value: false
        },
        {
          date: '12345',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1516 弄',
          zip: 200333,
          value: false
        },
        {
          date: '12345',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1516 弄',
          zip: 200333,
          value: false
        }
      ]
    }
  },
  methods: {

  }
}
</script>
<style lang="scss" scoped="scoped">
.changerecordtitle {
  height: 35px;
  width: 100%;
  line-height: 35px;
  padding-left: 10px;
  font-size: 12px;
  background: #f3f3f3;
}
</style>
<style>
</style>
